export default __webpack_public_path__ + "static/allrings-3c234abf2bc2cb125f5698be87c925e4.png";